// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */
/* SAM (Smart Analyst for Markets) — Proprietary Software */

* { margin: 0; padding: 0; box-sizing: border-box; }

/* ─── Dark Theme (default) ──────────────────────────────────────── */
:root {
  --bg: #0a0e17;
  --sidebar: #0f1520;
  --card: #151c2c;
  --border: #1e293b;
  --text: #e2e8f0;
  --text-dim: #64748b;
  --accent: #3b82f6;
  --green: #22c55e;
  --red: #ef4444;
  --orange: #f59e0b;
  --user-bg: #1e3a5f;
  --assistant-bg: #1a1f2e;
  --header-bg: #0b1018;
  --table-hover: rgba(59,130,246,0.04);
  --table-header-bg: #0d1117;
  --modal-bg: #151c2c;
  --modal-input-bg: #0d1117;
}

/* ─── Light Theme ────────────────────────────────────────────────── */
[data-theme="light"] {
  --bg: #f1f5f9;
  --sidebar: #e2e8f0;
  --card: #ffffff;
  --border: #cbd5e1;
  --text: #1e293b;
  --text-dim: #64748b;
  --accent: #2563eb;
  --green: #16a34a;
  --red: #dc2626;
  --orange: #d97706;
  --user-bg: #dbeafe;
  --assistant-bg: #f8fafc;
  --header-bg: #e2e8f0;
  --table-hover: rgba(37,99,235,0.04);
  --table-header-bg: #f1f5f9;
  --modal-bg: #ffffff;
  --modal-input-bg: #f1f5f9;
}

html, body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background: var(--bg);
  color: var(--text);
  height: 100vh;
  overflow: hidden;
  overflow-x: hidden;
  max-width: 100vw;
}

.app-root {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-x: hidden;
  max-width: 100vw;
}

/* ─── Ticker Tape ────────────────────────────────────────────────── */
.ticker-tape {
  height: 28px;
  background: var(--sidebar);
  border-bottom: 1px solid var(--border);
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
}

.ticker-scroll {
  display: flex;
  gap: 40px;
  white-space: nowrap;
  animation: ticker-slide 30s linear infinite;
  padding: 0 20px;
  height: 100%;
  align-items: center;
}

.ticker-scroll:hover {
  animation-play-state: paused;
}

@keyframes ticker-slide {
  0% { transform: translateX(0); }
  100% { transform: translateX(-33.33%); }
}

.ticker-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
}

.ticker-label {
  color: var(--text-dim);
  font-size: 10px;
}

.ticker-symbol {
  color: var(--accent);
  font-weight: 700;
}

.ticker-price {
  color: var(--text);
  font-weight: 600;
}

.ticker-change {
  font-weight: 600;
  font-size: 11px;
}

/* Split layout — top terminal, bottom chat */
.split-layout {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.split-top {
  min-height: 0;
  overflow: visible;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}

/* ─── Top View Tabs (Portfolio / Analysis) ─────────────────────── */
.top-view-tabs {
  display: flex;
  gap: 0;
  background: var(--sidebar);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.top-view-tab {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-dim);
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.15s;
}
.top-view-tab:hover { color: var(--text); background: var(--card); }
.top-view-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
  background: var(--card);
}
.top-view-tab svg { opacity: 0.7; }
.top-view-tab.active svg { opacity: 1; }

.top-view-spacer { flex: 1 1; }

.shortcuts-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: transparent;
  color: var(--text-dim);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  transition: all 0.15s;
}
.shortcuts-btn:hover { color: var(--accent); border-color: var(--accent); }

/* ─── Keyboard Shortcuts Panel ────────────────────────────────── */
.shortcuts-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  backdrop-filter: blur(2px);
}
.shortcuts-panel {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  min-width: 280px;
  box-shadow: 0 16px 48px rgba(0,0,0,0.4);
}
.shortcuts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.shortcuts-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}
.shortcuts-close {
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 20px;
  cursor: pointer;
}
.shortcuts-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.shortcut-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
  color: var(--text);
}
.shortcut-item kbd {
  display: inline-block;
  min-width: 28px;
  padding: 2px 8px;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  color: var(--accent);
}

.split-divider {
  height: 28px;
  background: var(--header-bg);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.split-divider.draggable {
  cursor: row-resize;
}

.divider-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

.divider-btn {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-dim);
  width: 24px;
  height: 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  padding: 0;
}

.divider-btn:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.divider-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: white;
}

.divider-grip {
  color: var(--text-dim);
  font-size: 14px;
  letter-spacing: 2px;
  opacity: 0.5;
  user-select: none;
}

.split-bottom {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
}

/* Chat header */
.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  background: var(--header-bg);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.chat-brand {
  font-size: 15px;
  font-weight: 800;
  color: var(--accent);
}

.chat-brand span {
  font-weight: 400;
  font-size: 11px;
  color: var(--text-dim);
  margin-left: 8px;
}

.chat-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.status-dot.live { background: var(--green); }
.status-dot.off { background: var(--red); }

.status-text {
  font-size: 11px;
  color: var(--text-dim);
}

.clear-btn {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-dim);
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
}
.clear-btn:hover {
  border-color: var(--red);
  color: var(--red);
}

.logout-btn {
  background: none;
  border: 1px solid var(--red);
  color: var(--red);
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.2s;
}
.logout-btn:hover {
  background: var(--red);
  color: white;
}

/* ─── Chat Tabs ──────────────────────────────────────────────────── */
.chat-tabs {
  display: flex;
  align-items: center;
  gap: 0;
  background: var(--sidebar);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  padding: 0 8px;
  overflow-x: auto;
}

.chat-tab {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 11px;
  color: var(--text-dim);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  white-space: nowrap;
}

.chat-tab:hover {
  color: var(--text);
  background: var(--table-hover);
}

.chat-tab.active {
  color: var(--accent);
  border-bottom-color: var(--accent);
}

.chat-tab-name {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chat-tab-close {
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 14px;
  cursor: pointer;
  padding: 0 2px;
  line-height: 1;
  opacity: 0.5;
}

.chat-tab-close:hover {
  color: var(--red);
  opacity: 1;
}

.chat-tab-add {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-dim);
  width: 22px;
  height: 22px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
  flex-shrink: 0;
  transition: all 0.2s;
}

.chat-tab-add:hover {
  border-color: var(--accent);
  color: var(--accent);
}

/* Chat messages */
.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
  max-width: 100%;
}

.chat-welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 10px;
}

.welcome-text {
  color: var(--text-dim);
  font-size: 13px;
}

.welcome-chips {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

.welcome-chips button {
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s;
}

.welcome-chips button:hover {
  border-color: var(--accent);
  background: rgba(59, 130, 246, 0.1);
}

/* Messages */
.message {
  display: flex;
  max-width: 90%;
  min-width: 0;
}

.message.user { align-self: flex-end; }
.message.assistant { align-self: flex-start; max-width: 95%; min-width: 0; }

.message.error .message-content {
  background: rgba(239, 68, 68, 0.1);
  border-color: var(--red);
}

.message-content {
  padding: 10px 14px;
  border-radius: 14px;
  font-size: 13px;
  line-height: 1.6;
  overflow-x: auto;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.user .message-content {
  background: var(--user-bg);
  border-radius: 14px 14px 4px 14px;
}

.assistant .message-content {
  background: var(--assistant-bg);
  border: 1px solid var(--border);
  border-radius: 14px 14px 14px 4px;
  padding: 16px 20px;
}

/* ─── SAM Response Typography ─────────────────────────────────── */
/* Headings — used as section titles */
.message-content h1,
.message-content h2,
.message-content h3,
.message-content h4 {
  margin: 0;
  padding: 0;
}

.message-content h1 {
  font-size: 16px;
  font-weight: 800;
  color: var(--accent);
  margin-bottom: 4px;
  letter-spacing: 0.3px;
}

.message-content h2 {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  margin-top: 16px;
  margin-bottom: 6px;
  padding-bottom: 4px;
  border-bottom: 1px solid var(--border);
}

.message-content h3 {
  font-size: 14px;
  font-weight: 700;
  color: var(--accent);
  margin-top: 14px;
  margin-bottom: 4px;
}

.message-content h4 {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-dim);
  margin-top: 10px;
  margin-bottom: 3px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
}

/* Paragraphs */
.message-content p {
  margin-bottom: 8px;
  line-height: 1.65;
}
.message-content p:last-child { margin-bottom: 0; }

/* Strong/Bold — accent colored for key terms */
.message-content strong {
  color: var(--accent);
  font-weight: 700;
}

/* Emphasis */
.message-content em {
  color: var(--text-dim);
  font-style: italic;
}

/* Inline code */
.message-content code {
  background: rgba(59, 130, 246, 0.1);
  color: var(--accent);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', monospace;
  border: 1px solid rgba(59, 130, 246, 0.15);
}
[data-theme="light"] .message-content code {
  background: rgba(37, 99, 235, 0.08);
  border-color: rgba(37, 99, 235, 0.12);
}

/* Code blocks */
.message-content pre {
  background: rgba(0, 0, 0, 0.35);
  padding: 12px 14px;
  border-radius: 8px;
  overflow-x: auto;
  margin: 8px 0;
  border: 1px solid var(--border);
}
[data-theme="light"] .message-content pre {
  background: rgba(0, 0, 0, 0.04);
}
.message-content pre code {
  background: none;
  padding: 0;
  border: none;
  color: var(--text);
  font-size: 12px;
}

/* ─── Tables — Financial Data Style ──────────────────────────── */
.message-content table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  margin: 8px 0;
  border-radius: 8px;
  overflow-x: auto;
  border: 1px solid var(--border);
  font-size: 12px;
  display: block;
  max-width: 100%;
}

.message-content thead {
  background: var(--header-bg);
}

.message-content th {
  padding: 8px 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-dim);
  text-align: left;
  border-bottom: 2px solid var(--border);
  white-space: nowrap;
}

.message-content td {
  padding: 7px 12px;
  font-size: 12px;
  text-align: left;
  border-bottom: 1px solid var(--border);
  color: var(--text);
}

.message-content tbody tr:last-child td {
  border-bottom: none;
}

.message-content tbody tr {
  transition: background 0.15s;
}

.message-content tbody tr:hover {
  background: var(--table-hover);
}

/* Alternate row shading */
.message-content tbody tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.08);
}
[data-theme="light"] .message-content tbody tr:nth-child(even) {
  background: rgba(0, 0, 0, 0.02);
}

/* ─── Lists — Verdicts, Key Points ───────────────────────────── */
.message-content ul,
.message-content ol {
  padding-left: 20px;
  margin: 6px 0;
}

.message-content li {
  margin: 4px 0;
  line-height: 1.6;
  padding-left: 4px;
}

.message-content li::marker {
  color: var(--accent);
}

/* Nested lists */
.message-content li > ul,
.message-content li > ol {
  margin: 2px 0;
}

/* ─── Horizontal Rule — Section Divider ──────────────────────── */
.message-content hr {
  border: none;
  border-top: 1px solid var(--border);
  margin: 14px 0;
}

/* ─── Blockquote — Verdicts, Warnings ────────────────────────── */
.message-content blockquote {
  margin: 8px 0;
  padding: 10px 14px;
  border-left: 3px solid var(--accent);
  background: rgba(59, 130, 246, 0.05);
  border-radius: 0 6px 6px 0;
  font-size: 13px;
}

.message-content blockquote p {
  margin-bottom: 4px;
}

.message-content blockquote p:last-child {
  margin-bottom: 0;
}

/* ─── Links ──────────────────────────────────────────────────── */
.message-content a {
  color: var(--accent);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.2s;
}

.message-content a:hover {
  border-bottom-color: var(--accent);
}

.typing {
  display: flex;
  gap: 4px;
  padding: 6px 0;
}
.typing span {
  width: 7px;
  height: 7px;
  background: var(--text-dim);
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out both;
}
.typing span:nth-child(1) { animation-delay: -0.32s; }
.typing span:nth-child(2) { animation-delay: -0.16s; }

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
}

/* Chat input */
.chat-input {
  padding: 10px 16px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 8px;
  background: var(--sidebar);
  flex-shrink: 0;
}

.chat-input textarea {
  flex: 1 1;
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  padding: 10px 14px;
  border-radius: 10px;
  font-size: 13px;
  font-family: inherit;
  resize: none;
  outline: none;
  min-height: 40px;
  max-height: 80px;
}

.chat-input textarea:focus { border-color: var(--accent); }

.chat-input button {
  background: var(--accent);
  color: white;
  border: none;
  padding: 0 20px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.chat-input button:disabled { opacity: 0.4; cursor: not-allowed; }
.chat-input button:hover:not(:disabled) { opacity: 0.85; }

/* Colors */
.green { color: var(--green); }
.red { color: var(--red); }

/* Scrollbar */
::-webkit-scrollbar { width: 5px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }

/* ─── Toast Notifications ────────────────────────────────────────── */
.toast-container {
  position: fixed;
  top: 36px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 360px;
}

.toast {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 12px;
  color: var(--text);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: 0 4px 20px rgba(0,0,0,0.3);
  cursor: pointer;
  animation: toast-in 0.3s ease-out;
}

@keyframes toast-in {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

.toast-alert {
  border-left: 3px solid var(--orange);
}

.toast-earnings {
  border-left: 3px solid var(--accent);
}

.toast-info {
  border-left: 3px solid var(--text-dim);
}

.toast-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.toast-msg {
  flex: 1 1;
}

.toast-close {
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 16px;
  cursor: pointer;
  padding: 0 2px;
}

.toast-close:hover {
  color: var(--text);
}

/* ─── Fancy Login Page ──────────────────────────────────────────── */
.login-page {
  position: relative;
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #030712;
  overflow: hidden;
}

.login-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

/* Floating orbs */
.login-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.3;
  z-index: 0;
  animation: orb-float 8s ease-in-out infinite;
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: #3b82f6;
  top: -10%;
  right: -5%;
  animation-delay: 0s;
}

.orb-2 {
  width: 350px;
  height: 350px;
  background: #8b5cf6;
  bottom: -10%;
  left: -5%;
  animation-delay: -3s;
}

.orb-3 {
  width: 250px;
  height: 250px;
  background: #06b6d4;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: -6s;
}

@keyframes orb-float {
  0%, 100% { transform: translateY(0) scale(1); }
  50% { transform: translateY(-30px) scale(1.05); }
}

.orb-3 {
  animation-name: orb-float-center;
}

@keyframes orb-float-center {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) translateY(-20px) scale(1.08); }
}

/* Ticker bar at top */
.login-ticker {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 36px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  overflow: hidden;
  z-index: 2;
}

.login-ticker-scroll {
  display: flex;
  gap: 32px;
  align-items: center;
  height: 100%;
  padding: 0 20px;
  animation: ticker-slide 40s linear infinite;
  white-space: nowrap;
}

.login-ticker-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.login-ticker-symbol {
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.login-ticker-price {
  color: #e2e8f0;
  font-size: 12px;
  font-weight: 600;
}

/* Glassmorphism login card */
.login-card {
  position: relative;
  z-index: 1;
  width: 420px;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
}

.login-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
}

.login-logo-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.login-logo-icon {
  flex-shrink: 0;
}

.login-logo-text {
  font-size: 22px;
  font-weight: 900;
  color: #ffffff;
  letter-spacing: 2px;
}

.login-logo-sub {
  font-size: 11px;
  color: #64748b;
  margin-top: 1px;
}

.login-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
  border-radius: 20px;
  font-size: 11px;
  color: #22c55e;
  font-weight: 500;
}

.login-badge-dot {
  width: 6px;
  height: 6px;
  background: #22c55e;
  border-radius: 50%;
  animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.login-welcome h2 {
  font-size: 22px;
  font-weight: 700;
  color: #f1f5f9;
  margin-bottom: 6px;
}

.login-welcome p {
  font-size: 13px;
  color: #64748b;
  margin-bottom: 24px;
}

/* Form */
.login-form-new {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.login-input-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.login-input-group label {
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.login-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 0 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.login-input-wrap:focus-within {
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.login-input-icon {
  color: #475569;
  flex-shrink: 0;
}

.login-input-wrap input {
  flex: 1 1;
  background: none;
  border: none;
  outline: none;
  color: #e2e8f0;
  font-size: 14px;
  padding: 12px 0;
  font-family: inherit;
}

.login-input-wrap input::placeholder {
  color: #475569;
}

.login-eye-btn {
  background: none;
  border: none;
  color: #475569;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.login-eye-btn:hover {
  color: #94a3b8;
}

.login-error-new {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 10px;
  color: #fca5a5;
  font-size: 13px;
}

.login-submit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  font-family: inherit;
  margin-top: 4px;
}

.login-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
  transform: translateY(-1px);
}

.login-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.login-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Stats bar */
.login-stats {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.login-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.login-stat-value {
  font-size: 16px;
  font-weight: 700;
  color: #3b82f6;
}

.login-stat-label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.login-stat-divider {
  width: 1px;
  height: 28px;
  background: rgba(255, 255, 255, 0.06);
}

.login-card-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 11px;
  color: #475569;
}

/* ─── Mobile Layout System ───────────────────────────────────────── */
/* By default, mobile layout is hidden */
.mobile-layout {
  display: none;
}

/* ─── Mobile Bottom Nav ──────────────────────────────────────────── */
.mobile-nav {
  display: flex;
  background: var(--sidebar);
  border-top: 1px solid var(--border);
  flex-shrink: 0;
  height: 56px;
}

.mobile-nav-btn {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: none;
  border: none;
  color: var(--text-dim);
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
  padding: 6px 0;
}

.mobile-nav-btn.active {
  color: var(--accent);
}

.mobile-nav-btn svg {
  width: 20px;
  height: 20px;
}

.mobile-nav-dot {
  position: absolute;
  top: 8px;
  right: calc(50% - 16px);
  width: 6px;
  height: 6px;
  background: var(--green);
  border-radius: 50%;
}

.mobile-content {
  flex: 1 1;
  overflow: hidden;
  overflow-x: hidden;
  min-height: 0;
  max-width: 100vw;
  width: 100%;
}

.mobile-panel {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

.mobile-chat-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

/* ─── Mobile Responsive ──────────────────────────────────────────── */
@media (max-width: 768px) {
  /* Hide desktop split, show mobile tab layout */
  .desktop-layout {
    display: none !important;
  }

  .mobile-layout {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
  }

  .mobile-content {
    overflow-x: hidden;
  }

  .mobile-panel {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .ticker-label {
    display: none;
  }

  .ticker-item {
    gap: 4px;
  }

  .ticker-tape {
    height: 24px;
  }

  /* ── Chat on mobile ──────────────────────────────── */
  .chat-header {
    padding: 6px 10px;
  }

  .chat-brand {
    font-size: 13px;
  }

  .chat-brand span {
    display: none;
  }

  .chat-messages {
    padding: 8px 10px;
  }

  .chat-input {
    padding: 8px 10px;
  }

  .chat-input textarea {
    font-size: 16px; /* Prevents iOS zoom */
    padding: 8px 10px;
  }

  .message {
    max-width: 98%;
  }

  .message.assistant {
    max-width: 98%;
  }

  .message-content {
    font-size: 13px;
    padding: 8px 10px;
    max-width: 100%;
    overflow-x: auto;
  }

  /* Tables inside chat — scroll horizontally inside bubble */
  .message-content table {
    font-size: 11px;
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .message-content th,
  .message-content td {
    padding: 5px 8px;
    font-size: 11px;
  }

  .message-content pre {
    font-size: 11px;
    max-width: calc(100vw - 60px);
  }

  .welcome-chips {
    gap: 4px;
  }

  .welcome-chips button {
    font-size: 11px;
    padding: 5px 8px;
  }

  /* ── Login page on mobile ────────────────────────── */
  .login-page {
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
  }

  .login-card {
    width: 92vw;
    max-width: 92vw;
    padding: 24px;
  }

  .login-card-header {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .login-orb {
    display: none;
  }

  .login-ticker {
    height: 28px;
  }

  .login-welcome h2 {
    font-size: 18px;
  }

  /* Modal full-width */
  .modal-overlay .modal {
    width: 90vw;
    max-width: 90vw;
  }

  /* Toast */
  .toast-container {
    left: 8px;
    right: 8px;
    max-width: none;
    top: 28px;
  }

  /* Chat tabs */
  .chat-tabs {
    padding: 0 6px;
  }

  .chat-tab {
    padding: 5px 8px;
    font-size: 10px;
  }
}

@media (max-width: 480px) {
  .ticker-tape {
    font-size: 10px;
    height: 22px;
  }

  .ticker-symbol {
    font-size: 10px;
  }

  .ticker-price,
  .ticker-change {
    font-size: 9px;
  }

  /* Hide feed badge on very small screens */
  .terminal-controls .feed-badge {
    display: none;
  }

  /* Search takes full row */
  .search-bar-wrap {
    width: 100%;
    order: 10;
  }

  .search-bar {
    width: 100%;
    flex: 1 1;
  }

  /* Summary bar */
  .summary-bar {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    padding: 6px 8px;
  }

  .summary-value {
    font-size: 13px;
  }

  .mobile-nav {
    height: 50px;
  }

  .mobile-nav-btn {
    font-size: 9px;
  }

  .mobile-nav-btn svg {
    width: 18px;
    height: 18px;
  }

  /* Equity table even more compact */
  .equity-table {
    font-size: 10px;
  }

  .equity-table th,
  .equity-table td {
    padding: 5px 4px;
  }

  /* Login adjustments */
  .login-card {
    width: 94vw;
    max-width: 94vw;
    padding: 20px;
    border-radius: 14px;
  }

  .login-logo-text {
    font-size: 18px;
  }

  .login-submit {
    padding: 10px;
    font-size: 13px;
  }

  .login-stats {
    gap: 14px;
  }

  .login-stat-value {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF,2DAA2D;;AAE3D,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;AAEnD,sEAAsE;AACtE;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,mCAAmC;EACnC,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sEAAsE;EACtE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,8BAA8B,EAAE;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,MAAM;EACN,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,kBAAkB,EAAE,uBAAuB,EAAE;AACnE;EACE,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;AACzB;AACA,oBAAoB,YAAY,EAAE;AAClC,2BAA2B,UAAU,EAAE;;AAEvC,mBAAmB,SAAO,EAAE;;AAE5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;AACA,uBAAuB,oBAAoB,EAAE,2BAA2B,EAAE;;AAE1E,oEAAoE;AACpE;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,4BAA4B;EAC5B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,mBAAmB,wBAAwB,EAAE;AAC7C,kBAAkB,sBAAsB,EAAE;;AAE1C;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd;;AAEA,gBAAgB,oBAAoB,EAAE;AACtC,qBAAqB,sBAAsB,EAAE,cAAc,EAAE,YAAY,EAAE;;AAE3E;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA,oEAAoE;AACpE,sCAAsC;AACtC;;;;EAIE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA,gCAAgC,gBAAgB,EAAE;;AAElD,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,+DAA+D;EAC/D,0CAA0C;AAC5C;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;AACjC;AACA;EACE,+BAA+B;AACjC;;AAEA,mEAAmE;AACnE;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;AACf;;AAEA,mEAAmE;AACnE;EACE,YAAY;EACZ,mCAAmC;EACnC,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,oCAAoC;EACpC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,gDAAgD;AAClD;AACA,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,uBAAuB,EAAE;;AAErD;EACE,gBAAgB,mBAAmB,EAAE;EACrC,MAAM,mBAAmB,EAAE;AAC7B;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B,2BAA2B,EAAE;;AAE1D;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,0CAA0C,aAAa,EAAE;;AAEzD,WAAW;AACX,SAAS,mBAAmB,EAAE;AAC9B,OAAO,iBAAiB,EAAE;;AAE1B,cAAc;AACd,sBAAsB,UAAU,EAAE;AAClC,4BAA4B,uBAAuB,EAAE;AACrD,4BAA4B,yBAAyB,EAAE,kBAAkB,EAAE;;AAE3E,uEAAuE;AACvE;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,sCAAsC;EACtC,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW,iCAAiC,EAAE;EAC9C,MAAM,wCAAwC,EAAE;AAClD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW,yCAAyC,EAAE;EACtD,MAAM,8DAA8D,EAAE;AACxE;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;EAC3B,kDAAkD;EAClD,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,uEAAuE;AACvE,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,+CAA+C;EAC/C;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA,uDAAuD;EACvD;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe,EAAE,sBAAsB;IACvC,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA,2DAA2D;EAC3D;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,uDAAuD;EACvD;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,WAAW;IACX,eAAe;EACjB;;EAEA,UAAU;EACV;IACE,SAAS;IACT,UAAU;IACV,eAAe;IACf,SAAS;EACX;;EAEA,cAAc;EACd;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;;EAEA,0BAA0B;EAC1B;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,SAAO;EACT;;EAEA,gBAAgB;EAChB;IACE,8BAA8B;IAC9B,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,mCAAmC;EACnC;IACE,eAAe;EACjB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Copyright (c) 2026 Smart Touch Infotech Private Limited. All rights reserved. */\n/* SAM (Smart Analyst for Markets) — Proprietary Software */\n\n* { margin: 0; padding: 0; box-sizing: border-box; }\n\n/* ─── Dark Theme (default) ──────────────────────────────────────── */\n:root {\n  --bg: #0a0e17;\n  --sidebar: #0f1520;\n  --card: #151c2c;\n  --border: #1e293b;\n  --text: #e2e8f0;\n  --text-dim: #64748b;\n  --accent: #3b82f6;\n  --green: #22c55e;\n  --red: #ef4444;\n  --orange: #f59e0b;\n  --user-bg: #1e3a5f;\n  --assistant-bg: #1a1f2e;\n  --header-bg: #0b1018;\n  --table-hover: rgba(59,130,246,0.04);\n  --table-header-bg: #0d1117;\n  --modal-bg: #151c2c;\n  --modal-input-bg: #0d1117;\n}\n\n/* ─── Light Theme ────────────────────────────────────────────────── */\n[data-theme=\"light\"] {\n  --bg: #f1f5f9;\n  --sidebar: #e2e8f0;\n  --card: #ffffff;\n  --border: #cbd5e1;\n  --text: #1e293b;\n  --text-dim: #64748b;\n  --accent: #2563eb;\n  --green: #16a34a;\n  --red: #dc2626;\n  --orange: #d97706;\n  --user-bg: #dbeafe;\n  --assistant-bg: #f8fafc;\n  --header-bg: #e2e8f0;\n  --table-hover: rgba(37,99,235,0.04);\n  --table-header-bg: #f1f5f9;\n  --modal-bg: #ffffff;\n  --modal-input-bg: #f1f5f9;\n}\n\nhtml, body {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background: var(--bg);\n  color: var(--text);\n  height: 100vh;\n  overflow: hidden;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n.app-root {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow-x: hidden;\n  max-width: 100vw;\n}\n\n/* ─── Ticker Tape ────────────────────────────────────────────────── */\n.ticker-tape {\n  height: 28px;\n  background: var(--sidebar);\n  border-bottom: 1px solid var(--border);\n  overflow: hidden;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.ticker-scroll {\n  display: flex;\n  gap: 40px;\n  white-space: nowrap;\n  animation: ticker-slide 30s linear infinite;\n  padding: 0 20px;\n  height: 100%;\n  align-items: center;\n}\n\n.ticker-scroll:hover {\n  animation-play-state: paused;\n}\n\n@keyframes ticker-slide {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-33.33%); }\n}\n\n.ticker-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n}\n\n.ticker-label {\n  color: var(--text-dim);\n  font-size: 10px;\n}\n\n.ticker-symbol {\n  color: var(--accent);\n  font-weight: 700;\n}\n\n.ticker-price {\n  color: var(--text);\n  font-weight: 600;\n}\n\n.ticker-change {\n  font-weight: 600;\n  font-size: 11px;\n}\n\n/* Split layout — top terminal, bottom chat */\n.split-layout {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.split-top {\n  min-height: 0;\n  overflow: visible;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  z-index: 2;\n}\n\n/* ─── Top View Tabs (Portfolio / Analysis) ─────────────────────── */\n.top-view-tabs {\n  display: flex;\n  gap: 0;\n  background: var(--sidebar);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.top-view-tab {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-dim);\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.top-view-tab:hover { color: var(--text); background: var(--card); }\n.top-view-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n  background: var(--card);\n}\n.top-view-tab svg { opacity: 0.7; }\n.top-view-tab.active svg { opacity: 1; }\n\n.top-view-spacer { flex: 1; }\n\n.shortcuts-btn {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 1px solid var(--border);\n  background: transparent;\n  color: var(--text-dim);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n  transition: all 0.15s;\n}\n.shortcuts-btn:hover { color: var(--accent); border-color: var(--accent); }\n\n/* ─── Keyboard Shortcuts Panel ────────────────────────────────── */\n.shortcuts-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1100;\n  backdrop-filter: blur(2px);\n}\n.shortcuts-panel {\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 20px;\n  min-width: 280px;\n  box-shadow: 0 16px 48px rgba(0,0,0,0.4);\n}\n.shortcuts-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n.shortcuts-header h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text);\n}\n.shortcuts-close {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 20px;\n  cursor: pointer;\n}\n.shortcuts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.shortcut-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 13px;\n  color: var(--text);\n}\n.shortcut-item kbd {\n  display: inline-block;\n  min-width: 28px;\n  padding: 2px 8px;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--accent);\n}\n\n.split-divider {\n  height: 28px;\n  background: var(--header-bg);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.split-divider.draggable {\n  cursor: row-resize;\n}\n\n.divider-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.divider-btn {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-dim);\n  width: 24px;\n  height: 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n  padding: 0;\n}\n\n.divider-btn:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n.divider-btn.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: white;\n}\n\n.divider-grip {\n  color: var(--text-dim);\n  font-size: 14px;\n  letter-spacing: 2px;\n  opacity: 0.5;\n  user-select: none;\n}\n\n.split-bottom {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n/* Chat header */\n.chat-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 16px;\n  background: var(--header-bg);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.chat-brand {\n  font-size: 15px;\n  font-weight: 800;\n  color: var(--accent);\n}\n\n.chat-brand span {\n  font-weight: 400;\n  font-size: 11px;\n  color: var(--text-dim);\n  margin-left: 8px;\n}\n\n.chat-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n.status-dot.live { background: var(--green); }\n.status-dot.off { background: var(--red); }\n\n.status-text {\n  font-size: 11px;\n  color: var(--text-dim);\n}\n\n.clear-btn {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-dim);\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.clear-btn:hover {\n  border-color: var(--red);\n  color: var(--red);\n}\n\n.logout-btn {\n  background: none;\n  border: 1px solid var(--red);\n  color: var(--red);\n  padding: 3px 10px;\n  border-radius: 5px;\n  font-size: 11px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.logout-btn:hover {\n  background: var(--red);\n  color: white;\n}\n\n/* ─── Chat Tabs ──────────────────────────────────────────────────── */\n.chat-tabs {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  background: var(--sidebar);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  padding: 0 8px;\n  overflow-x: auto;\n}\n\n.chat-tab {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 12px;\n  font-size: 11px;\n  color: var(--text-dim);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.chat-tab:hover {\n  color: var(--text);\n  background: var(--table-hover);\n}\n\n.chat-tab.active {\n  color: var(--accent);\n  border-bottom-color: var(--accent);\n}\n\n.chat-tab-name {\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chat-tab-close {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0 2px;\n  line-height: 1;\n  opacity: 0.5;\n}\n\n.chat-tab-close:hover {\n  color: var(--red);\n  opacity: 1;\n}\n\n.chat-tab-add {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-dim);\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 4px;\n  flex-shrink: 0;\n  transition: all 0.2s;\n}\n\n.chat-tab-add:hover {\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* Chat messages */\n.chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.chat-welcome {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 10px;\n}\n\n.welcome-text {\n  color: var(--text-dim);\n  font-size: 13px;\n}\n\n.welcome-chips {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.welcome-chips button {\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 6px 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s;\n}\n\n.welcome-chips button:hover {\n  border-color: var(--accent);\n  background: rgba(59, 130, 246, 0.1);\n}\n\n/* Messages */\n.message {\n  display: flex;\n  max-width: 90%;\n  min-width: 0;\n}\n\n.message.user { align-self: flex-end; }\n.message.assistant { align-self: flex-start; max-width: 95%; min-width: 0; }\n\n.message.error .message-content {\n  background: rgba(239, 68, 68, 0.1);\n  border-color: var(--red);\n}\n\n.message-content {\n  padding: 10px 14px;\n  border-radius: 14px;\n  font-size: 13px;\n  line-height: 1.6;\n  overflow-x: auto;\n  max-width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.user .message-content {\n  background: var(--user-bg);\n  border-radius: 14px 14px 4px 14px;\n}\n\n.assistant .message-content {\n  background: var(--assistant-bg);\n  border: 1px solid var(--border);\n  border-radius: 14px 14px 14px 4px;\n  padding: 16px 20px;\n}\n\n/* ─── SAM Response Typography ─────────────────────────────────── */\n/* Headings — used as section titles */\n.message-content h1,\n.message-content h2,\n.message-content h3,\n.message-content h4 {\n  margin: 0;\n  padding: 0;\n}\n\n.message-content h1 {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--accent);\n  margin-bottom: 4px;\n  letter-spacing: 0.3px;\n}\n\n.message-content h2 {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text);\n  margin-top: 16px;\n  margin-bottom: 6px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid var(--border);\n}\n\n.message-content h3 {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--accent);\n  margin-top: 14px;\n  margin-bottom: 4px;\n}\n\n.message-content h4 {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-dim);\n  margin-top: 10px;\n  margin-bottom: 3px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-size: 11px;\n}\n\n/* Paragraphs */\n.message-content p {\n  margin-bottom: 8px;\n  line-height: 1.65;\n}\n.message-content p:last-child { margin-bottom: 0; }\n\n/* Strong/Bold — accent colored for key terms */\n.message-content strong {\n  color: var(--accent);\n  font-weight: 700;\n}\n\n/* Emphasis */\n.message-content em {\n  color: var(--text-dim);\n  font-style: italic;\n}\n\n/* Inline code */\n.message-content code {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--accent);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', monospace;\n  border: 1px solid rgba(59, 130, 246, 0.15);\n}\n[data-theme=\"light\"] .message-content code {\n  background: rgba(37, 99, 235, 0.08);\n  border-color: rgba(37, 99, 235, 0.12);\n}\n\n/* Code blocks */\n.message-content pre {\n  background: rgba(0, 0, 0, 0.35);\n  padding: 12px 14px;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 8px 0;\n  border: 1px solid var(--border);\n}\n[data-theme=\"light\"] .message-content pre {\n  background: rgba(0, 0, 0, 0.04);\n}\n.message-content pre code {\n  background: none;\n  padding: 0;\n  border: none;\n  color: var(--text);\n  font-size: 12px;\n}\n\n/* ─── Tables — Financial Data Style ──────────────────────────── */\n.message-content table {\n  border-collapse: separate;\n  border-spacing: 0;\n  width: 100%;\n  margin: 8px 0;\n  border-radius: 8px;\n  overflow-x: auto;\n  border: 1px solid var(--border);\n  font-size: 12px;\n  display: block;\n  max-width: 100%;\n}\n\n.message-content thead {\n  background: var(--header-bg);\n}\n\n.message-content th {\n  padding: 8px 12px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-dim);\n  text-align: left;\n  border-bottom: 2px solid var(--border);\n  white-space: nowrap;\n}\n\n.message-content td {\n  padding: 7px 12px;\n  font-size: 12px;\n  text-align: left;\n  border-bottom: 1px solid var(--border);\n  color: var(--text);\n}\n\n.message-content tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.message-content tbody tr {\n  transition: background 0.15s;\n}\n\n.message-content tbody tr:hover {\n  background: var(--table-hover);\n}\n\n/* Alternate row shading */\n.message-content tbody tr:nth-child(even) {\n  background: rgba(0, 0, 0, 0.08);\n}\n[data-theme=\"light\"] .message-content tbody tr:nth-child(even) {\n  background: rgba(0, 0, 0, 0.02);\n}\n\n/* ─── Lists — Verdicts, Key Points ───────────────────────────── */\n.message-content ul,\n.message-content ol {\n  padding-left: 20px;\n  margin: 6px 0;\n}\n\n.message-content li {\n  margin: 4px 0;\n  line-height: 1.6;\n  padding-left: 4px;\n}\n\n.message-content li::marker {\n  color: var(--accent);\n}\n\n/* Nested lists */\n.message-content li > ul,\n.message-content li > ol {\n  margin: 2px 0;\n}\n\n/* ─── Horizontal Rule — Section Divider ──────────────────────── */\n.message-content hr {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 14px 0;\n}\n\n/* ─── Blockquote — Verdicts, Warnings ────────────────────────── */\n.message-content blockquote {\n  margin: 8px 0;\n  padding: 10px 14px;\n  border-left: 3px solid var(--accent);\n  background: rgba(59, 130, 246, 0.05);\n  border-radius: 0 6px 6px 0;\n  font-size: 13px;\n}\n\n.message-content blockquote p {\n  margin-bottom: 4px;\n}\n\n.message-content blockquote p:last-child {\n  margin-bottom: 0;\n}\n\n/* ─── Links ──────────────────────────────────────────────────── */\n.message-content a {\n  color: var(--accent);\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.2s;\n}\n\n.message-content a:hover {\n  border-bottom-color: var(--accent);\n}\n\n.typing {\n  display: flex;\n  gap: 4px;\n  padding: 6px 0;\n}\n.typing span {\n  width: 7px;\n  height: 7px;\n  background: var(--text-dim);\n  border-radius: 50%;\n  animation: bounce 1.4s infinite ease-in-out both;\n}\n.typing span:nth-child(1) { animation-delay: -0.32s; }\n.typing span:nth-child(2) { animation-delay: -0.16s; }\n\n@keyframes bounce {\n  0%, 80%, 100% { transform: scale(0); }\n  40% { transform: scale(1); }\n}\n\n/* Chat input */\n.chat-input {\n  padding: 10px 16px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 8px;\n  background: var(--sidebar);\n  flex-shrink: 0;\n}\n\n.chat-input textarea {\n  flex: 1;\n  background: var(--card);\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: none;\n  outline: none;\n  min-height: 40px;\n  max-height: 80px;\n}\n\n.chat-input textarea:focus { border-color: var(--accent); }\n\n.chat-input button {\n  background: var(--accent);\n  color: white;\n  border: none;\n  padding: 0 20px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.chat-input button:disabled { opacity: 0.4; cursor: not-allowed; }\n.chat-input button:hover:not(:disabled) { opacity: 0.85; }\n\n/* Colors */\n.green { color: var(--green); }\n.red { color: var(--red); }\n\n/* Scrollbar */\n::-webkit-scrollbar { width: 5px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb { background: var(--border); border-radius: 3px; }\n\n/* ─── Toast Notifications ────────────────────────────────────────── */\n.toast-container {\n  position: fixed;\n  top: 36px;\n  right: 16px;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 360px;\n}\n\n.toast {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 12px;\n  color: var(--text);\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.3);\n  cursor: pointer;\n  animation: toast-in 0.3s ease-out;\n}\n\n@keyframes toast-in {\n  from { transform: translateX(100%); opacity: 0; }\n  to { transform: translateX(0); opacity: 1; }\n}\n\n.toast-alert {\n  border-left: 3px solid var(--orange);\n}\n\n.toast-earnings {\n  border-left: 3px solid var(--accent);\n}\n\n.toast-info {\n  border-left: 3px solid var(--text-dim);\n}\n\n.toast-icon {\n  font-size: 16px;\n  flex-shrink: 0;\n}\n\n.toast-msg {\n  flex: 1;\n}\n\n.toast-close {\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 16px;\n  cursor: pointer;\n  padding: 0 2px;\n}\n\n.toast-close:hover {\n  color: var(--text);\n}\n\n/* ─── Fancy Login Page ──────────────────────────────────────────── */\n.login-page {\n  position: relative;\n  width: 100%;\n  max-width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #030712;\n  overflow: hidden;\n}\n\n.login-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n}\n\n/* Floating orbs */\n.login-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.3;\n  z-index: 0;\n  animation: orb-float 8s ease-in-out infinite;\n}\n\n.orb-1 {\n  width: 400px;\n  height: 400px;\n  background: #3b82f6;\n  top: -10%;\n  right: -5%;\n  animation-delay: 0s;\n}\n\n.orb-2 {\n  width: 350px;\n  height: 350px;\n  background: #8b5cf6;\n  bottom: -10%;\n  left: -5%;\n  animation-delay: -3s;\n}\n\n.orb-3 {\n  width: 250px;\n  height: 250px;\n  background: #06b6d4;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation-delay: -6s;\n}\n\n@keyframes orb-float {\n  0%, 100% { transform: translateY(0) scale(1); }\n  50% { transform: translateY(-30px) scale(1.05); }\n}\n\n.orb-3 {\n  animation-name: orb-float-center;\n}\n\n@keyframes orb-float-center {\n  0%, 100% { transform: translate(-50%, -50%) scale(1); }\n  50% { transform: translate(-50%, -50%) translateY(-20px) scale(1.08); }\n}\n\n/* Ticker bar at top */\n.login-ticker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 36px;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  overflow: hidden;\n  z-index: 2;\n}\n\n.login-ticker-scroll {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  height: 100%;\n  padding: 0 20px;\n  animation: ticker-slide 40s linear infinite;\n  white-space: nowrap;\n}\n\n.login-ticker-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.login-ticker-symbol {\n  color: #94a3b8;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.login-ticker-price {\n  color: #e2e8f0;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* Glassmorphism login card */\n.login-card {\n  position: relative;\n  z-index: 1;\n  width: 420px;\n  background: rgba(15, 23, 42, 0.75);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  padding: 32px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);\n}\n\n.login-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 28px;\n}\n\n.login-logo-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.login-logo-icon {\n  flex-shrink: 0;\n}\n\n.login-logo-text {\n  font-size: 22px;\n  font-weight: 900;\n  color: #ffffff;\n  letter-spacing: 2px;\n}\n\n.login-logo-sub {\n  font-size: 11px;\n  color: #64748b;\n  margin-top: 1px;\n}\n\n.login-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 10px;\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  border-radius: 20px;\n  font-size: 11px;\n  color: #22c55e;\n  font-weight: 500;\n}\n\n.login-badge-dot {\n  width: 6px;\n  height: 6px;\n  background: #22c55e;\n  border-radius: 50%;\n  animation: pulse-dot 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n.login-welcome h2 {\n  font-size: 22px;\n  font-weight: 700;\n  color: #f1f5f9;\n  margin-bottom: 6px;\n}\n\n.login-welcome p {\n  font-size: 13px;\n  color: #64748b;\n  margin-bottom: 24px;\n}\n\n/* Form */\n.login-form-new {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.login-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.login-input-group label {\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.login-input-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  padding: 0 14px;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.login-input-wrap:focus-within {\n  border-color: rgba(59, 130, 246, 0.5);\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.login-input-icon {\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.login-input-wrap input {\n  flex: 1;\n  background: none;\n  border: none;\n  outline: none;\n  color: #e2e8f0;\n  font-size: 14px;\n  padding: 12px 0;\n  font-family: inherit;\n}\n\n.login-input-wrap input::placeholder {\n  color: #475569;\n}\n\n.login-eye-btn {\n  background: none;\n  border: none;\n  color: #475569;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.login-eye-btn:hover {\n  color: #94a3b8;\n}\n\n.login-error-new {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 10px;\n  color: #fca5a5;\n  font-size: 13px;\n}\n\n.login-submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-family: inherit;\n  margin-top: 4px;\n}\n\n.login-submit:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2563eb, #1d4ed8);\n  box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);\n  transform: translateY(-1px);\n}\n\n.login-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.login-spinner {\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Stats bar */\n.login-stats {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.login-stat {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n}\n\n.login-stat-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #3b82f6;\n}\n\n.login-stat-label {\n  font-size: 10px;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.login-stat-divider {\n  width: 1px;\n  height: 28px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.login-card-footer {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 11px;\n  color: #475569;\n}\n\n/* ─── Mobile Layout System ───────────────────────────────────────── */\n/* By default, mobile layout is hidden */\n.mobile-layout {\n  display: none;\n}\n\n/* ─── Mobile Bottom Nav ──────────────────────────────────────────── */\n.mobile-nav {\n  display: flex;\n  background: var(--sidebar);\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n  height: 56px;\n}\n\n.mobile-nav-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  background: none;\n  border: none;\n  color: var(--text-dim);\n  font-size: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s;\n  padding: 6px 0;\n}\n\n.mobile-nav-btn.active {\n  color: var(--accent);\n}\n\n.mobile-nav-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.mobile-nav-dot {\n  position: absolute;\n  top: 8px;\n  right: calc(50% - 16px);\n  width: 6px;\n  height: 6px;\n  background: var(--green);\n  border-radius: 50%;\n}\n\n.mobile-content {\n  flex: 1;\n  overflow: hidden;\n  overflow-x: hidden;\n  min-height: 0;\n  max-width: 100vw;\n  width: 100%;\n}\n\n.mobile-panel {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-width: 100vw;\n  width: 100%;\n}\n\n.mobile-chat-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-x: hidden;\n  max-width: 100vw;\n  width: 100%;\n}\n\n/* ─── Mobile Responsive ──────────────────────────────────────────── */\n@media (max-width: 768px) {\n  /* Hide desktop split, show mobile tab layout */\n  .desktop-layout {\n    display: none !important;\n  }\n\n  .mobile-layout {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .mobile-content {\n    overflow-x: hidden;\n  }\n\n  .mobile-panel {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .ticker-label {\n    display: none;\n  }\n\n  .ticker-item {\n    gap: 4px;\n  }\n\n  .ticker-tape {\n    height: 24px;\n  }\n\n  /* ── Chat on mobile ──────────────────────────────── */\n  .chat-header {\n    padding: 6px 10px;\n  }\n\n  .chat-brand {\n    font-size: 13px;\n  }\n\n  .chat-brand span {\n    display: none;\n  }\n\n  .chat-messages {\n    padding: 8px 10px;\n  }\n\n  .chat-input {\n    padding: 8px 10px;\n  }\n\n  .chat-input textarea {\n    font-size: 16px; /* Prevents iOS zoom */\n    padding: 8px 10px;\n  }\n\n  .message {\n    max-width: 98%;\n  }\n\n  .message.assistant {\n    max-width: 98%;\n  }\n\n  .message-content {\n    font-size: 13px;\n    padding: 8px 10px;\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  /* Tables inside chat — scroll horizontally inside bubble */\n  .message-content table {\n    font-size: 11px;\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .message-content th,\n  .message-content td {\n    padding: 5px 8px;\n    font-size: 11px;\n  }\n\n  .message-content pre {\n    font-size: 11px;\n    max-width: calc(100vw - 60px);\n  }\n\n  .welcome-chips {\n    gap: 4px;\n  }\n\n  .welcome-chips button {\n    font-size: 11px;\n    padding: 5px 8px;\n  }\n\n  /* ── Login page on mobile ────────────────────────── */\n  .login-page {\n    width: 100%;\n    max-width: 100vw;\n    overflow-x: hidden;\n  }\n\n  .login-card {\n    width: 92vw;\n    max-width: 92vw;\n    padding: 24px;\n  }\n\n  .login-card-header {\n    flex-direction: column;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .login-orb {\n    display: none;\n  }\n\n  .login-ticker {\n    height: 28px;\n  }\n\n  .login-welcome h2 {\n    font-size: 18px;\n  }\n\n  /* Modal full-width */\n  .modal-overlay .modal {\n    width: 90vw;\n    max-width: 90vw;\n  }\n\n  /* Toast */\n  .toast-container {\n    left: 8px;\n    right: 8px;\n    max-width: none;\n    top: 28px;\n  }\n\n  /* Chat tabs */\n  .chat-tabs {\n    padding: 0 6px;\n  }\n\n  .chat-tab {\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .ticker-tape {\n    font-size: 10px;\n    height: 22px;\n  }\n\n  .ticker-symbol {\n    font-size: 10px;\n  }\n\n  .ticker-price,\n  .ticker-change {\n    font-size: 9px;\n  }\n\n  /* Hide feed badge on very small screens */\n  .terminal-controls .feed-badge {\n    display: none;\n  }\n\n  /* Search takes full row */\n  .search-bar-wrap {\n    width: 100%;\n    order: 10;\n  }\n\n  .search-bar {\n    width: 100%;\n    flex: 1;\n  }\n\n  /* Summary bar */\n  .summary-bar {\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n    padding: 6px 8px;\n  }\n\n  .summary-value {\n    font-size: 13px;\n  }\n\n  .mobile-nav {\n    height: 50px;\n  }\n\n  .mobile-nav-btn {\n    font-size: 9px;\n  }\n\n  .mobile-nav-btn svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  /* Equity table even more compact */\n  .equity-table {\n    font-size: 10px;\n  }\n\n  .equity-table th,\n  .equity-table td {\n    padding: 5px 4px;\n  }\n\n  /* Login adjustments */\n  .login-card {\n    width: 94vw;\n    max-width: 94vw;\n    padding: 20px;\n    border-radius: 14px;\n  }\n\n  .login-logo-text {\n    font-size: 18px;\n  }\n\n  .login-submit {\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .login-stats {\n    gap: 14px;\n  }\n\n  .login-stat-value {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
